
import { defineComponent, onMounted, PropType, reactive, ref, computed, onBeforeUpdate, watch } from 'vue'
import { TabView } from './TabNav.vue'
import QuantityContainer from '@/pages/Dashboard/components/QuantityContainer.vue'

export interface ModalView {
  id: string,
  label?: string
}

export default defineComponent({
  name: 'MetaModal',
  components: { QuantityContainer },
  props: {
    views: {
      type: Array as PropType<Array<ModalView>>,
      required: true
    },
    active: {
      type: Object as PropType<ModalView>
    },
    showModal: {
      type: Boolean
      // required: true
    },
    disablePrevious: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:active', 'next', 'previous', 'update:showModal', 'close'],
  setup (props, { emit }) {

    const previousIndex = ref()

    const show = computed({
      get: () => props.showModal === undefined ? false : props.showModal,
      set: () => close()
    })

    const activeIndex = computed<number>(() => (!props.active || !props.views?.length) ? -1 : props.views.findIndex(v => v.id === props.active?.id))
    // watch(() => props.active, (current, prev) => {
    //   if (current !== prev) previousIndex.value = current
    // })

    function switchTab (tab: TabView) {
      emit('update:active', tab)
    }

    function close () {
      emit('update:showModal')
      emit('update:active', props.views[0])
      emit('close')
    }

    function to (index) {
      previousIndex.value = activeIndex.value
      if (index < 0 || (index > props.views?.length - 1)) return
      emit('update:active', props.views[index])
    }

    function setPrevious (index) {
      previousIndex.value = Math.max(index, 0)
    }

    function previous () {
      if (!previousIndex.value) return
      to(Math.max(Math.max(previousIndex.value - 1, 0)))
      emit('previous')
    }

    function next () {
      to(Math.min(activeIndex.value + 1, (props.views?.length || 1) - 1))
      emit('previous')
    }

    onBeforeUpdate(() => {
      if (!props.active) emit('update:active', props.views[0])
    })

    return {
      setPrevious,
      activeIndex,
      switchTab,
      close,
      show,
      previous,
      next,
      to
    }
  }
})
